import { apiHelper } from '@/util'

export const ssoAuthService = {
    getTelegramConfig,
    telegramVerify
}

//API urls
const TELEGRAM = {
    TELEGRAM: '/telegram',
    CONFIG: 'config',
    VERIFY: 'verify',
}

function getTelegramConfig() {
    return apiHelper().get(`${TELEGRAM.TELEGRAM}/${TELEGRAM.CONFIG}`)
}

function telegramVerify(telegramUser) {
    // telegramUser = {id: number, first_name: string, username: string, auth_date: number, hash: string}
    const requestBody = {
        telegram_data: telegramUser
    }
    return apiHelper().post(`${TELEGRAM.TELEGRAM}/${TELEGRAM.VERIFY}`, requestBody)
}